function Grid({ children, className }) {
  return (
    <div className="container">
      <div className={`row ${className}`}>{children}</div>
    </div>
  );
}

export default Grid;
